import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';

import { UnicornResponseDto } from './dtos/unicorn.dto';
import {
  UnicornPayloadInput,
  UnicornPayloadMapper,
} from './mappers/unicorn.payload.mapper';

@Injectable({ providedIn: 'root' })
export class UnicornsApi {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _http = inject(HttpClient);

  private readonly _url = `${this._env.pureSpectrum.url}/buyers/v2/unicorn`;
  private readonly _mapper = new UnicornPayloadMapper();

  /**
   * No loading context on purpose: this runs unprompted on every nested-quota
   * change, so a global overlay would block the page for a check the buyer
   * never asked for. The banner just appears once the answer lands.
   *
   * Returns only the ids — the response echoes back the quotas we posted, so
   * everything else is already in state under those same ids.
   */
  public findUnicorns(input: UnicornPayloadInput): Observable<string[]> {
    return this._http
      .post<UnicornResponseDto>(this._url, this._mapper.toPayload(input))
      .pipe(
        map((dto) =>
          (dto.survey_unicorns ?? []).map((quota) => quota.buyer_quota_id),
        ),
      );
  }
}
